module.exports = __webpack_public_path__ + "img/vip.b0b0159b.svg";